<div class="modal-header border-0">
  <h4 class="modal-title pull-left"><a href="javascript:void(0);" class="mr-4"><img src="assets/images/back.svg" draggable="false" alt="back"></a>Edit Image</h4>
  <div aria-label="Close" (click)="onCancel()" class="close pull-right">
    <span aria-hidden="true">×</span>
  </div>
</div>


  <div class="modal-body">
    <image-cropper class="img_cropper" [imageBase64]="imageBase64" [maintainAspectRatio]="true" [aspectRatio]="1 / 1" format="png"
      (imageCropped)="onImageCropped($event)" [transform]="transform"></image-cropper>
      <div class="zoom_btns">
        <button (click)="onZoomOut()"><img src="assets/images/zoom-out.svg" draggable="false" alt="zoom-out"></button>
        <ngx-slider [(value)]="scale" class="Zoomslider" [options]="cropOptions" (valueChange)="onChangeScale()"></ngx-slider>
        <button (click)="onZoomIn()"><img src="assets/images/zoom-in.svg" draggable="false" alt="zoom-in"></button>
      </div>
  </div>

  <div class="modal-footer justify-content-between">
    <button class="btn default LinkBtn" (click)="onCancel()">Cancel</button>
    <button class="btn btn-rbv warning btn_custom" (click)="onConfirm()">
      Submit
    </button>
  </div>
